// extracted by mini-css-extract-plugin
export default {"filterSummary":"FilterSummary_filterSummary__Ye-Cx","filterSummary__text":"FilterSummary_filterSummary__text__in6w7"};